/** Candidates domain storage. Per-tab (sessionStorage) search state for the candidate-introductions log listing. */
import Storage from '../index';
import StorageKeys from '../keys';

const INTRODUCTIONS = 'introductions';

const candidates = {
    getIntroductionsSearchState: (lang) => Storage.get(StorageKeys.logsSearchState(INTRODUCTIONS, lang), null),
    setIntroductionsSearchState: (lang, state) =>
        Storage.set(StorageKeys.logsSearchState(INTRODUCTIONS, lang), state),
};

export default candidates;
